var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoRose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_722_6529)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.332 20.5C10.332 14.9772 14.8092 10.5 20.332 10.5H30.332C35.8549 10.5 40.332 14.9772 40.332 20.5V40.5H20.332C14.8092 40.5 10.332 36.0228 10.332 30.5V20.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_722_6529)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2171 26.7099V32.3465C19.2171 32.5601 19.2976 32.7649 19.441 32.9159C19.5843 33.0669 19.7788 33.1517 19.9815 33.1517H30.6833C30.8861 33.1517 31.0805 33.0669 31.2238 32.9159C31.3672 32.7649 31.4477 32.5601 31.4477 32.3465V26.7099H19.2171ZM23.4214 17.8524C22.9699 17.8522 22.5257 17.9724 22.1301 18.2018C21.7346 18.4312 21.4006 18.7622 21.1593 19.1642C20.918 19.5661 20.7771 20.0259 20.7499 20.5006C20.7226 20.9754 20.8099 21.4497 21.0035 21.8793L18.4527 21.8785C18.2499 21.8785 18.0555 21.9633 17.9121 22.1144C17.7688 22.2654 17.6882 22.4702 17.6882 22.6837V25.0994C17.6882 25.313 17.7688 25.5178 17.9121 25.6688C18.0555 25.8198 18.2499 25.9047 18.4527 25.9047H32.2121C32.4149 25.9047 32.6093 25.8198 32.7527 25.6688C32.896 25.5178 32.9766 25.313 32.9766 25.0994V22.6837C32.9766 22.4702 32.896 22.2654 32.7527 22.1144C32.6093 21.9633 32.4149 21.8785 32.2121 21.8785L29.6613 21.8793C29.9336 21.2767 29.9941 20.5919 29.832 19.9468C29.6699 19.3016 29.2957 18.738 28.776 18.3562C28.2564 17.9745 27.625 17.7994 26.9942 17.8621C26.3635 17.9248 25.7743 18.2212 25.3316 18.6987C25.0832 18.4301 24.7861 18.2169 24.458 18.0715C24.1298 17.9261 23.7773 17.8516 23.4214 17.8524ZM27.2434 19.4628C27.5379 19.463 27.821 19.5825 28.0341 19.7965C28.2473 20.0106 28.374 20.3028 28.3882 20.6126C28.4023 20.9225 28.3028 21.2261 28.1102 21.4608C27.9175 21.6954 27.6466 21.8429 27.3535 21.8729L27.2434 21.8785H26.0968V20.6707C26.0968 20.3704 26.203 20.0809 26.3947 19.8587C26.5863 19.6364 26.8496 19.4973 27.1334 19.4685L27.2434 19.4628ZM23.4214 19.4628L23.5314 19.4685C23.7964 19.4952 24.0443 19.6182 24.2326 19.8164C24.4209 20.0146 24.5378 20.2756 24.5634 20.5547L24.568 20.6707V21.8785H23.4214L23.3113 21.8729C23.0277 21.8439 22.7645 21.7047 22.5729 21.4825C22.3814 21.2602 22.2753 20.9708 22.2753 20.6707C22.2753 20.3705 22.3814 20.0811 22.5729 19.8588C22.7645 19.6366 23.0277 19.4974 23.3113 19.4685L23.4214 19.4628Z",
    fill: "url(#paint0_linear_722_6529)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_722_6529",
    x: 0.332031,
    y: 0.5,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.589833 0 0 0 0 0.108333 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_722_6529"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_722_6529",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_722_6529",
    x: 17.6875,
    y: 17.8496,
    width: 17.2891,
    height: 17.3027,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.458333 0 0 0 0 0.1375 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "color-burn",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_722_6529"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_722_6529",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_722_6529",
    x1: 32.9766,
    y1: 25.5007,
    x2: 17.6882,
    y2: 25.5007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F15836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF924F"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoRose);
export default __webpack_public_path__ + "static/media/ico-rose.56022654a1a474d35aa3761b89cb295f.svg";
export { ForwardRef as ReactComponent };